import { render } from "./CertificateList.vue?vue&type=template&id=c8bbd350"
import script from "./CertificateList.vue?vue&type=script&lang=js"
export * from "./CertificateList.vue?vue&type=script&lang=js"

import "./CertificateList.vue?vue&type=style&index=0&id=c8bbd350&lang=scss"
import "./CertificateList.vue?vue&type=style&index=1&id=c8bbd350&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__